<h2>{{ question.title }}</h2>
<p>{{ question.description }}</p>


<!--<container-element [ngSwitch]="question.constructor.name">
   <app-yes-no-question *ngSwitchCase="'YesNoQuestion'"  [question]="question"></app-yes-no-question>
   <app-rating-question *ngSwitchCase="'RatingQuestion'" [question]="question"></app-rating-question>
</container-element>-->


<!--<ion-list>
  <ion-radio-group value="yes">

    <ion-item>
      <ion-label>Da, bil sem tam.</ion-label>
      <ion-radio color="secondary" slot="start" value="yes"></ion-radio>
    </ion-item>

    <ion-item>
      <ion-label>Ne, zato je ne morem oceniti.</ion-label>
      <ion-radio color="secondary" slot="start" value="griff"></ion-radio>
    </ion-item>

  </ion-radio-group>
</ion-list>-->

<br />